import usePushNotification from '@/hooks/usePushNotification';

const NotificationInjector = () => {
  usePushNotification();

  return <></>;
};

export default NotificationInjector;
